export const getBaseHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
